import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserSessionPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import {getStorage} from "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyB7kRuKhw1lesNx7osOqMwXbjMY2QBUrwg",
  authDomain: "mrc-lines.firebaseapp.com",
  databaseURL: "https://mrc-lines-default-rtdb.firebaseio.com",
  projectId: "mrc-lines",
  storageBucket: "mrc-lines.appspot.com",
  messagingSenderId: "177722643165",
  appId: "1:177722843165:web:d4c5e06b5fafd92aae4134"
  // measurementId removed to disable Google Analytics
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth();
export const functions = getFunctions(app);
export const storage = getStorage(app);

// Set session-only persistence (clears on browser tab/window close)
// This MUST complete before auth checks, so it's awaited via onAuthStateChanged
setPersistence(auth, browserSessionPersistence)
  .catch(() => {
    // Session persistence falls back to Firebase defaults when unavailable.
  });

// Ensure auth is ready for the app
export const onAuthReady = new Promise((resolve) => {
  const unsubscribe = auth.onAuthStateChanged((user) => {
    unsubscribe(); // Stop listening after first check
    resolve(user);
  });
});